
import {
  formatByCountry,
  formatInputByCountry,
  parseByCountry,
  resolveCountry
} from "@/app/infrastructures/misc/Utils";
import { DashboardController } from "@/app/ui/controllers/DashboardController";
import { Options, prop, Vue } from "vue-class-component";
import {
  CodDashboardCourierDetailRequest,
  CourierDailyDepositRequest
} from "@/data/payload/api/DashboardRequests";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import parsingErrorResponse from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";
import { ModalMessageEntities } from "@/domain/entities/MainApp";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean
  });
  detailDataCourier = prop<any>({
    default: null
  });
  isPicShuttle = prop<boolean>({
    default: false,
    type: Boolean
  });
  type = prop<string>({
    default: "courier",
    type: String
  });
}

@Options({
  emits: ["update:modelValue"],
  components: {}
})
export default class PopupSetorHarianKurir extends Vue.with(Props) {
  get titlePopupSetorHarian() {
    if (this.isPicShuttle) {
      return "Setor Harian PIC Shuttle";
    }
    return "Setor Harian Kurir";
  }
  get actorName() {
    if (this.isPicShuttle) {
      return "PIC Shuttle";
    }
    return "Kurir";
  }
  closeDialog() {
    this.$emit("update:modelValue", false);
  }
  forceCloseDialog() {
    this.$emit("update:modelValue", false);
  }
  resetForm() {
    this.form.deposit = 0;
    this.form.DEX = 0;
    this.form.CODREJ = 0;
    this.isErrorDeposit = false;
    this.isErrorCodrej = false;
    this.isErrorDex = false;
  }
  async onSelectDatePicker(date: Date) {
    MainAppController.showLoading();
    try {
      const response = await DashboardController.fetchDetailCourierPartnerCodDashboard(
        new CodDashboardCourierDetailRequest({
          filterDate: this.$moment(date).format("YYYY-MM-DD"),
          driverPhone: this.detailData.courierPhoneNumber
        })
      );
      this.detailData.depositMoney = response.totalOutstanding;
      this.detailData.sttDex = response.totalSttDexOutstanding;
      this.detailData.sttCodrej = response.totalSttCodrejOutstanding;
    } catch (e) {
      this.detailData.depositMoney = 0;
      this.detailData.sttDex = 0;
      this.detailData.sttCodrej = 0;
    } finally {
      this.resetForm();
      MainAppController.closeLoading();
    }
  }

  get validationDepositMoney() {
    return this.detailData.depositMoney === 0 ? false : !this.form.deposit;
  }
  get validationCodrej() {
    return this.detailData.sttCodrej === 0 ? false : !this.form.CODREJ;
  }
  get validationDex() {
    return this.detailData.sttDex === 0 ? false : !this.form.DEX;
  }
  get isZero() {
    return (
      this.detailData.depositMoney === 0 &&
      this.detailData.sttCodrej === 0 &&
      this.detailData.sttDex === 0
    );
  }
  get isDisabled() {
    if (this.isZero) {
      return true;
    }
    return (
      this.validationDepositMoney ||
      this.validationCodrej ||
      this.validationDex ||
      this.isErrorDeposit ||
      this.isErrorCodrej ||
      this.isErrorDex
    );
  }

  detailData = {
    courierName: this.detailDataCourier.courierName,
    courierPhoneNumber: this.detailDataCourier.phoneNumber,
    depositMoney: this.detailDataCourier.depositMoney,
    sttCodrej: this.detailDataCourier.sttCodrej,
    sttDex: this.detailDataCourier.sttDex
  };

  form = {
    date: DashboardController.filterDateCodDashboard,
    deposit: this.detailData.depositMoney === 0 ? 0 : "",
    CODREJ: this.detailData.sttCodrej === 0 ? 0 : "",
    DEX: this.detailData.sttDex === 0 ? 0 : ""
  };
  maxDate = new Date();

  get prefixCurrency() {
    return resolveCountry() === "MY" ? "RM" : "Rp";
  }

  formatMoney(value: string) {
    return formatInputByCountry(value, { type: "money" });
  }
  formatNumber(value: string) {
    return value.replace(/[\D]+/g, "");
  }
  formatPriceRp(value: number) {
    return formatByCountry(value, { type: "money", prefix: this.prefixCurrency });
  }
  isErrorDeposit = false;
  isErrorCodrej = false;
  isErrorDex = false;
  validationInput(value: string, type: string) {
    const inputValue = value.toString();
    const inputDeposit = parseByCountry(inputValue);
    const inputNumber = Number(value);
    if (type === "deposit") {
      this.isErrorDeposit =
        inputDeposit !== this.detailData.depositMoney &&
        this.detailData.depositMoney !== 0;
    }
    if (type === "codrej") {
      this.isErrorCodrej =
        inputNumber !== this.detailData.sttCodrej &&
        this.detailData.sttCodrej !== 0;
    }
    if (type === "dex") {
      this.isErrorDex =
        inputNumber !== this.detailData.sttDex && this.detailData.sttDex !== 0;
    }
    return false;
  }
  get isErrorCaptionHeight() {
    return !this.isErrorDeposit && !this.isErrorCodrej && !this.isErrorDex;
  }

  async postCourierDailyDeposit() {
    try {
      MainAppController.showLoading();
      const response = await DashboardController.postCourierDailyDeposit({
        type: this.type,
        payload: new CourierDailyDepositRequest({
          driverPhone: this.detailData.courierPhoneNumber,
          picPhone: this.detailData.courierPhoneNumber,
          filterDate: this.$moment(this.form.date).format("YYYY-MM-DD"),
          totalAmount: this.detailData.depositMoney,
          totalSttDex: this.detailData.sttDex,
          totalSttCodrej: this.detailData.sttCodrej
        })
      });
      if (response.success) {
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            title: `Setor harian ${this.actorName} berhasil`,
            textSuccess: "OK",
            onSubmit: () => {
              MainAppController.closeMessageModal();
              this.forceCloseDialog();
            }
          })
        );
      }
    } catch (e) {
      MainAppController.showErrorMessage(parsingErrorResponse(e));
    } finally {
      MainAppController.closeLoading();
    }
  }
}
